import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import { formatLabel, formatCcRange } from "layouts/dutyEstimator/constants";

export default function dutyRateTableData({ dutyRateList = [], onEdit, onDelete }) {
  return {
    columns: [
      { Header: "HS Code", accessor: "hsCode", align: "left" },
      { Header: "Category", accessor: "category", width: "26%", align: "left" },
      { Header: "Condition", accessor: "condition", align: "center" },
      { Header: "Fuel", accessor: "fuel", align: "center" },
      { Header: "Engine", accessor: "engine", align: "center" },
      { Header: "Duty Rate", accessor: "dutyRate", align: "center" },
      { Header: "Status", accessor: "status", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: dutyRateList.map((rate) => ({
      hsCode: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {rate?.hsCode || "—"}
        </MDTypography>
      ),
      category: (
        <MDBox>
          <MDTypography variant="button" fontWeight="medium" display="block">
            {formatLabel(rate?.category)}
            {rate?.bodyType ? ` — ${formatLabel(rate.bodyType)}` : ""}
          </MDTypography>
          {rate?.description ? (
            <MDTypography variant="caption" color="text">
              {rate.description}
            </MDTypography>
          ) : null}
        </MDBox>
      ),
      condition: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatLabel(rate?.condition)}
        </MDTypography>
      ),
      fuel: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatLabel(rate?.fuelType)}
        </MDTypography>
      ),
      engine: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatCcRange(rate?.engineCcMin, rate?.engineCcMax)}
        </MDTypography>
      ),
      dutyRate: (
        <MDTypography variant="button" fontWeight="bold">
          {Number(rate?.dutyRate ?? 0)}%
        </MDTypography>
      ),
      status: (
        <Chip
          size="small"
          label={rate?.isActive === false ? "Inactive" : "Active"}
          sx={{
            backgroundColor: rate?.isActive === false ? "#eeeeee" : "#e8f5e9",
            color: rate?.isActive === false ? "#616161" : "#2e7d32",
            fontWeight: 600,
          }}
        />
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <Button size="small" onClick={() => onEdit(rate)}>
            Edit
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => onDelete(rate?.id)}
            sx={{ backgroundColor: "#d32f2f", color: "#fff", "&:hover": { backgroundColor: "#9a0007" } }}
          >
            Delete
          </Button>
        </MDBox>
      ),
    })),
  };
}
